import { CircularProgress, type CircularProgressProps } from '@tempmee/react';
import { type CSSProperties } from 'react';

interface ICenteredSpinnerProps extends CircularProgressProps {
  /**
   * Minimum height for the centering container. Pass this when the spinner lives in an
   * auto-height parent (e.g. a tab panel) where `height: 100%` collapses to the spinner —
   * it gives the flex container a concrete area to vertically center within.
   */
  minHeight?: CSSProperties['minHeight'];
}

/**
 * DS `CircularProgress` wrapped in a flex container that fills its parent
 * (width/height 100%) and centers the indicator on both axes — for full-render /
 * full-panel loading states (where the spinner is returned as the whole component
 * or fills a sized container).
 *
 * For a small inline spinner, render `<CircularProgress>` from `@tempmee/react`
 * directly.
 */
export const CenteredSpinner = ({ minHeight, ...rest }: ICenteredSpinnerProps) => (
  <div
    style={{
      display: 'flex',
      flex: 1,
      width: '100%',
      height: '100%',
      minHeight,
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress {...rest} />
  </div>
);
